/* eslint-disable max-len */
import axios from 'axios';
// import { Auth } from 'aws-amplify';
import { baseURL } from '../config';
import { authHeader } from '../CommonMethods/Auth-Headers';
import { getAuthItem } from '../CommonMethods/authSession';


/**
 * This is an asynchronous function that retrieves data from an API endpoint using axios and returns an
 * object with a boolean error value and the retrieved data.
 * @param endpoint - The `endpoint` parameter is a string that represents the specific API endpoint
 * that the function is trying to access. It is concatenated with the `baseURL` variable to form the
 * complete URL for the API request.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean value
 * indicating whether an error occurred during the API call. The "data" property contains the response
 * data from the API call.
 */
async function GetAPI(endpoint) {
    const headers = await authHeader()
    const data = await axios.get(`${baseURL}${endpoint}`, {
        headers: headers,
    });
    return { error: false, data: data.data };
}

/**
 * This is an asynchronous function that sends a POST request to an API endpoint with a given payload
 * and authentication headers.
 * @param body - The body parameter is the data that will be sent in the request body of the HTTP POST
 * request. It can be any valid JavaScript object or data type that can be serialized into JSON format.
 * @param endpoint - The endpoint parameter is a string that represents the specific API endpoint that
 * the function will send a POST request to. It is typically a URL that specifies the location of the
 * API resource that the function will interact with.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean value
 * indicating whether an error occurred during the API call. The "data" property contains the response
 * data from the API call.
 */
async function PostAPI(body, endpoint) {
    let payload = {};
    payload = body;
    const headers = await authHeader()
    const data = await axios.post(`${baseURL}${endpoint}`, payload, {
        headers: headers,
    });
    return { error: false, data: data.data };
}

/**
 * This is an async function that sends a PATCH request to an API endpoint with a given payload and
 * authentication headers.
 * @param body - The `body` parameter is the data that will be sent in the request body of the PATCH
 * request. It could be an object, an array, or any other data type that can be serialized into JSON.
 * @param endpoint - The endpoint parameter is a string that represents the specific API endpoint that
 * the PATCH request will be sent to. It is typically a URL that specifies the location of the resource
 * that needs to be updated.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean value
 * indicating whether an error occurred during the API call. The "data" property contains the response
 * data from the API call.
 */
async function PatchAPI(body, endpoint) {
    let payload = {};
    payload = body;
    const headers = await authHeader()
    const data = await axios.patch(`${baseURL}${endpoint}`, payload, {
        headers: headers,
    });
    return { error: false, data: data.data };
}

async function appVersion(body) {
    const payload = body;
    const headers = await authHeader()
    const data = await axios.post(`https://8fs3io4nu3.execute-api.ap-south-1.amazonaws.com/dev/list`,payload, {
        headers: headers,
    });
    return { error: false, data: data.data };
}
async function systemConfigDataFromAdmin() {
    const idToken = getAuthItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    const data = await axios.get(`${baseURL}system-configuration/`, {
        headers: headers,
    });
    return { error: false, data: data.data };
    
}


export const dataService = {
    appVersion,
    PatchAPI,
    GetAPI,
    PostAPI,
    systemConfigDataFromAdmin,
}
